module.exports = __webpack_public_path__ + "media/images/checkbox-off-641a25464bf83a8f9949d1bbb2e1e89c.svg";